/* unplugin-vue-components disabled */import { render } from "./Markdown.vue?vue&type=template&id=3389a12c"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"

import "./Markdown.vue?vue&type=style&index=0&id=3389a12c&lang=scss"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__